import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ActivitiesDataService {

  private uri: string = `${environment.apiUrl}activity`;

  constructor(
    private http: HttpClient
  ) {}

  getActivitiesByChallenge(id : any): Observable<any> {
    return this.http.get(this.uri + '/by_challenge/' + id);
  }

}
